module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_9006.9a58d0d5.png";